import React, { useState } from 'react';
import { CameraIcon, UserRoundIcon, ShieldCheckIcon, FingerprintIcon, GlobeIcon, BellIcon, MailIcon, SmartphoneIcon, MegaphoneIcon, PaletteIcon, CoinsIcon, HelpCircleIcon, HeadphonesIcon, MapPinIcon, FileTextIcon, LogOutIcon, ChevronRightIcon, PencilIcon } from 'lucide-react';
import { StatusBar } from './StatusBar';
import { BottomNav, NavTarget } from './BottomNav';
export function SettingsScreen({
  onNavigate
}: {
  onNavigate?: (t: NavTarget) => void;
}) {
  const [push, setPush] = useState(true);
  const [email, setEmail] = useState(true);
  const [sms, setSms] = useState(false);
  const [marketing, setMarketing] = useState(false);
  return <div className="relative flex flex-col w-full h-full overflow-hidden" style={{
    backgroundColor: '#F4F7FA'
  }} data-id="element-566">
      <StatusBar data-id="element-567" />

      <div className="flex items-center justify-between px-5 pt-2 pb-3" data-id="element-568">
        <h1 className="tracking-tight" style={{
        fontSize: 22,
        fontWeight: 700,
        color: '#1A1A1A',
        lineHeight: 1.2
      }} data-id="element-569">
          Settings
        </h1>
      </div>

      <div className="flex-1 overflow-y-auto px-5 pb-3" data-id="element-570">
        {/* Profile card */}
        <div className="rounded-3xl p-4 mb-5" style={{
        background: 'linear-gradient(135deg, #009AC7 0%, #007FA5 100%)',
        color: '#FFFFFF',
        boxShadow: '0 12px 28px -16px rgba(0,154,199,0.5)'
      }} data-id="element-571">
          <div className="flex items-center gap-3.5" data-id="element-572">
            <div className="relative" data-id="element-573">
              <span className="flex items-center justify-center rounded-full overflow-hidden" style={{
              width: 68,
              height: 68,
              backgroundColor: 'rgba(255,255,255,0.18)',
              border: '2px solid rgba(255,255,255,0.7)',
              color: '#FFFFFF',
              fontSize: 24,
              fontWeight: 700,
              letterSpacing: '0.02em'
            }} data-id="element-574">
                KP
              </span>
              <button type="button" aria-label="Change profile photo" className="absolute -bottom-0.5 -right-0.5 flex items-center justify-center rounded-full transition-transform active:scale-[0.95]" style={{
              width: 26,
              height: 26,
              backgroundColor: '#FFFFFF',
              color: '#009AC7',
              border: '2px solid #009AC7'
            }} data-id="element-575">
                <CameraIcon size={13} strokeWidth={2.5} data-id="element-576" />
              </button>
            </div>
            <div className="flex-1 min-w-0" data-id="element-577">
              <div className="tracking-tight" style={{
              fontSize: 17,
              fontWeight: 700
            }} data-id="element-578">
                Kasun Perera
              </div>
              <div className="mt-0.5" style={{
              fontSize: 12,
              opacity: 0.88,
              fontWeight: 500
            }} data-id="element-579">
                NIC 1985 1234 5678
              </div>
              <div className="mt-0.5" style={{
              fontSize: 11.5,
              opacity: 0.82,
              fontWeight: 500
            }} data-id="element-580">
                kasun.p@email.com
              </div>
            </div>
            <button type="button" aria-label="Edit profile" className="flex items-center justify-center rounded-full transition-colors active:bg-white/15" style={{
            width: 38,
            height: 38,
            backgroundColor: 'rgba(255,255,255,0.18)',
            border: '1px solid rgba(255,255,255,0.28)'
          }} data-id="element-581">
              <PencilIcon size={16} data-id="element-582" />
            </button>
          </div>
        </div>

        {/* Account */}
        <SectionLabel data-id="element-583">Account</SectionLabel>
        <Group data-id="element-584">
          <Row icon={<UserRoundIcon size={18} data-id="element-586" />} tint="#009AC7" label="Personal information" sub="Name, address, mobile, email" data-id="element-585" />
          <Row icon={<ShieldCheckIcon size={18} data-id="element-588" />} tint="#10B981" label="Security" sub="Password, security questions" data-id="element-587" />
          <Row icon={<FingerprintIcon size={18} data-id="element-590" />} tint="#8B5CF6" label="Biometric login" sub="Fingerprint & Face ID" right={<Toggle on={true} data-id="element-591" />} data-id="element-589" />
          <Row icon={<SmartphoneIcon size={18} data-id="element-593" />} tint="#F59E0B" label="Trusted devices" sub="2 devices linked" last data-id="element-592" />
        </Group>

        {/* Notifications */}
        <SectionLabel data-id="element-594">Notifications</SectionLabel>
        <Group data-id="element-595">
          <Row icon={<BellIcon size={18} data-id="element-597" />} tint="#009AC7" label="Push notifications" sub="Transactions, alerts, and updates" right={<Toggle on={push} onChange={setPush} data-id="element-598" />} withChevron={false} data-id="element-596" />
          <Row icon={<MailIcon size={18} data-id="element-600" />} tint="#8B5CF6" label="Email alerts" sub="Monthly statements & receipts" right={<Toggle on={email} onChange={setEmail} data-id="element-601" />} withChevron={false} data-id="element-599" />
          <Row icon={<SmartphoneIcon size={18} data-id="element-603" />} tint="#10B981" label="SMS alerts" sub="High-value transactions only" right={<Toggle on={sms} onChange={setSms} data-id="element-604" />} withChevron={false} data-id="element-602" />
          <Row icon={<MegaphoneIcon size={18} data-id="element-606" />} tint="#F59E0B" label="Marketing & offers" sub="Promotions and product news" right={<Toggle on={marketing} onChange={setMarketing} data-id="element-607" />} withChevron={false} last data-id="element-605" />
        </Group>

        {/* Preferences */}
        <SectionLabel data-id="element-608">Preferences</SectionLabel>
        <Group data-id="element-609">
          <Row icon={<GlobeIcon size={18} data-id="element-611" />} tint="#009AC7" label="Language" sub="English" data-id="element-610" />
          <Row icon={<CoinsIcon size={18} data-id="element-613" />} tint="#10B981" label="Currency" sub="LKR — Sri Lankan Rupee" data-id="element-612" />
          <Row icon={<PaletteIcon size={18} data-id="element-615" />} tint="#8B5CF6" label="Appearance" sub="Light" last data-id="element-614" />
        </Group>

        {/* Help & support */}
        <SectionLabel data-id="element-616">Help & support</SectionLabel>
        <Group data-id="element-617">
          <Row icon={<HelpCircleIcon size={18} data-id="element-619" />} tint="#009AC7" label="FAQ" sub="Frequently asked questions" data-id="element-618" />
          <Row icon={<HeadphonesIcon size={18} data-id="element-621" />} tint="#10B981" label="Contact support" sub="24/7 live agents" data-id="element-620" />
          <Row icon={<MapPinIcon size={18} data-id="element-623" />} tint="#F59E0B" label="Find a branch" sub="Locate RDB branches near you" data-id="element-622" />
          <Row icon={<FileTextIcon size={18} data-id="element-625" />} tint="#64748B" label="Terms & Privacy" sub="Legal & compliance documents" last data-id="element-624" />
        </Group>

        {/* Sign out */}
        <button type="button" className="w-full flex items-center justify-center gap-2 rounded-2xl bg-white transition-colors active:bg-neutral-50 mb-3" style={{
        minHeight: 54,
        border: '1px solid #FEE2E2',
        color: '#DC2626',
        fontSize: 14,
        fontWeight: 700
      }} data-id="element-626">
          <LogOutIcon size={18} data-id="element-627" />
          Sign out
        </button>
        <div className="text-center mb-3" style={{
        fontSize: 11,
        color: '#94A3B8',
        fontWeight: 500
      }} data-id="element-628">
          RDB Mobile Banking · v3.2.1
        </div>
      </div>

      <BottomNav active="settings" onNavigate={onNavigate} data-id="element-629" />
    </div>;
}
function SectionLabel({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="mb-2 px-1" style={{
    fontSize: 11,
    fontWeight: 700,
    color: '#64748B',
    letterSpacing: '0.08em',
    textTransform: 'uppercase'
  }} data-id="element-630">
      {children}
    </div>;
}
function Group({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="rounded-2xl bg-white overflow-hidden mb-5" style={{
    border: '1px solid #E5EAF0'
  }} data-id="element-631">
      {children}
    </div>;
}
function Row({
  icon,
  tint,
  label,
  sub,
  right,
  withChevron = true,
  last
}: {
  icon: React.ReactNode;
  tint: string;
  label: string;
  sub?: string;
  right?: React.ReactNode;
  withChevron?: boolean;
  last?: boolean;
}) {
  return <button type="button" className="w-full flex items-center gap-3 px-4 py-3 text-left transition-colors active:bg-neutral-50" style={{
    borderBottom: last ? 'none' : '1px solid #F1F5F9'
  }} data-id="element-632">
      <span className="shrink-0 flex items-center justify-center rounded-xl" style={{
      width: 36,
      height: 36,
      backgroundColor: `${tint}18`,
      color: tint
    }} data-id="element-633">
        {icon}
      </span>
      <div className="flex-1 min-w-0" data-id="element-634">
        <div className="truncate" style={{
        fontSize: 13.5,
        fontWeight: 700,
        color: '#1A1A1A'
      }} data-id="element-635">
          {label}
        </div>
        {sub && <div className="mt-0.5 truncate" style={{
        fontSize: 11.5,
        color: '#64748B',
        fontWeight: 500
      }} data-id="element-636">
            {sub}
          </div>}
      </div>
      {right && <div className="shrink-0" data-id="element-637">{right}</div>}
      {withChevron && !right && <ChevronRightIcon size={18} style={{
      color: '#94A3B8'
    }} data-id="element-638" />}
    </button>;
}
function Toggle({
  on,
  onChange
}: {
  on: boolean;
  onChange?: (v: boolean) => void;
}) {
  return <button type="button" role="switch" aria-checked={on} onClick={e => {
    e.stopPropagation();
    onChange?.(!on);
  }} className="relative rounded-full transition-colors" style={{
    width: 44,
    height: 26,
    backgroundColor: on ? '#009AC7' : '#CBD5E1'
  }} data-id="element-639">
      <span className="absolute top-[2px] rounded-full bg-white transition-all" style={{
      width: 22,
      height: 22,
      left: on ? 20 : 2,
      boxShadow: '0 1px 3px rgba(15,23,42,0.25)'
    }} data-id="element-640" />
    </button>;
}